import * as React from 'react';
import { Card } from 'material-ui';
import { get } from 'lodash';
import { compose, withHandlers, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { saveAs } from 'file-saver';
import { DateField, Date } from '@components/form';
import { required } from '@utils/validators';
import { getActualDate } from '@utils/utils';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';

import { handOverTickets, getReportHandOver } from '@modules/tickets/_ticketsActions';
import { TicketsCancelFormBasic } from '@modules/tickets/TicketsCancelFormBasic';
import { Col } from 'react-flexbox-grid';

export const enhance = compose<any, any>(
  withHandlers({
    onSubmit: ({ closeItem, checkedItems, refresh, handleLoader, handOverTemplate }) => async data => {
      handleLoader(true);
      const result = await handOverTickets({ checkedItems, ...data });
      if (result) {
        const report = await getReportHandOver(handOverTemplate, result);

        if (report) {
          const blob = await report.blob();

          saveAs(blob, get(handOverTemplate, 'fileName', 'report.xslx'));
        }
        if (refresh) {
          refresh();
        }
        await closeItem();
      }
      handleLoader(false);
    }
  }),
  withProps(({ checkedItems }) => ({
    initialValues: {
      cashDate: getActualDate(),
      checkedItems
    },
    totalAmount: checkedItems.reduce((acc, { value = 0 }) => acc + value, 0)
  })),
  breadcrumbs(() => [{ label: 'Přesun' }]),
  reduxForm({ form: 'ticekts-send-cash' })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, totalAmount }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <Col md={12}>
          <h4>Odevzdat hotovost</h4>
        </Col>
        <TicketsCancelFormBasic />
        <Col md={12}>
          <DateField
            component={Date}
            label="Datum a čas odezvdání hotovosti *"
            name="cashDate"
            validate={[required]}
            dateOnly={false}
          />
        </Col>
        <Col md={12}>
          <h4>{`Celková částka: ${totalAmount}`}</h4>
        </Col>
        <Button type="submit" label="Odevzdat" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);
export const TicketsHandOverForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsHandOverForm.tsx